<template>
  <UKbd>
    <slot />
  </UKbd>
</template>
